// extracted by mini-css-extract-plugin
export default {"smart-image":"d2e7f4","smart-image__tag":"fa9d21","smart-image__tag--contain":"f01c60","smart-image__skeleton":"e80d81","pulse":"f4a10d"};